import { GetStaticPaths } from 'next';

export { DynamicLander as default } from 'processes/DynamicLanders/DynamicLanders';
export { getStaticProps } from 'processes/DynamicLanders/getStaticProps';

export const getStaticPaths = (() => ({
  paths: [],
  fallback: 'blocking'
})) satisfies GetStaticPaths;
